import { NgModule } from '@angular/core';
import { ThirdCmsComponent } from './third-cms.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ThirdCmsComponent],
  imports: [CommonModule],
  exports: [ThirdCmsComponent],
})
export class ThirdCmsModule {}
